// const getIp = () => {
//   const ip = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
//   const url = window.location.href
//   const res = ip.exec(url) || [null]
//   return res[0]
// }
// // const ip = getIp()
// // const base =  ip + '/'
// // const api  = 'base_api'
// // const dcm  = 'base_dcm'
// // const pacs =  12346

// // export const api_url = base + api
// // export const dcm_url = base + dcm
// // export const pacs_url = ip + ':' + pacs + '/'
// const ip             = getIp()
// // 服务器本机ip
// // export const domain        = '192.168.1.101';

// //服务器ris html端口
// // export const base_port     = '12345';

// //服务器api端口
// const api_port        = '9600';//9602
// // 9601上传
// //浏览器端口
// const pacsview_port   = '9603';

// //dicom下载端口
// const dcm_port        = '9999';

// const baseApiUrl = isPro ? realApiUrl : process.env.BASE_URL;
// const basePacsUrl = isPro ? realPacsUrl : process.env.BASEPACSURL;
// const baseDcmUrl = isPro ? realDcmUrl : process.env.BASEDCMURL;
// const pacsApiUrl = isPro ? realApiUrl : process.env.PACSAPIURL;

// export const base     = ip ? `https://${ip}:${api_port}` : 'https://work.api.pacsonline.cn'
// const pacsview_url    = ip ? `${ip}:${pacsview_port}` : 'static.pacsview.pacsonline.cn' //'ychz.local.pacsview.pc.pacsonline.cn'
// const dcm_url         = ip ? `${ip}:${dcm_port}` : ''
// export const studyUrl = `https://${pacsview_url}/#/pc?studyurl=${base}/inter/dcquery/get_studiesinfo?address=${dcm_url}&study_id=`

const getIp = () => {
  const ip = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
  const url = window.location.href;
  const res = ip.exec(url) || [null];
  return res[0];
};
// const ip = getIp()
// const base =  ip + '/'
// const api  = 'base_api'
// const dcm  = 'base_dcm'
// const pacs =  12346

// export const api_url = base + api
// export const dcm_url = base + dcm
// export const pacs_url = ip + ':' + pacs + '/'
const ip = getIp();
// const ip = "111.63.59.20"
// 服务器本机ip
// export const domain        = '192.168.1.101';

//服务器ris html端口
// export const base_port     = '12345';

//服务器api端口
const api_port = "9600"; //9602
// 9601上传
//浏览器端口
const pacsview_port = "9603";

//dicom下载端口
const dcm_port = "9999";
const protocol = window.location.protocol
const hostname = window.location.hostname
const port = window.location.port

// http://111.63.59.20:9600

const url = hostname; //测试服
// const url = 'yxy.cdswsjkw.cn'; //测试服
// const url = "http://192.168.1.22:88";
//export const base = ip ? `https://${ip}:${api_port}/zskkapi` : url
// export const base = {
//   base: ip ? `https://${ip}:${api_port}/zskkapi` : url
// };
const pacsview_new_url = ip
    ? protocol + `//${ip}:${pacsview_port}`
    : protocol + "//"+ url +"/mobile_view"
const request_url = ip
    ? protocol + `//${ip}:${pacsview_port}`
    : protocol + "//"+ url +"/mobile_query"
const dcm_url = ip ? `${ip}:${pacsview_port}/downdcm` : ""

export const config = {
    baseurl: ip ? `${protocol}//${ip}:${api_port}/zskkapi` : `${protocol}//${url}/zskkapi`,
    pacsview_url: `${pacsview_new_url}/#/mobile?studyurl=${request_url}/query/?address=${dcm_url}&study_id=`,
    ipurl: ip ? `${protocol}//${ip}:${port}` : `${protocol}//${url}`,
}
